import {Base} from './Base';
import {Metadata} from './Metadata';

const SideNav = {
  Base,
  Metadata,
};

export {SideNav};
